"use client";
import styled from "styled-components";
import { Accordion, AccordionSummary, AccordionDetails, Box, } from '@mui/material';
import { useEffect, useState } from "react";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext"; 
import { getExpertColumn, getHorseByMeetingRace, getTrackAnalysisExperts, getMeetingPmPoolStatus } from "@/app/utils/request/requestList";
import { useMyContext } from '@/app/utils/MyContext';
import { generateHorseProfileUrl, getSearchParams, generateUrl, setRacesDetailLoading, parseBetline, generateAdobeDataRaceNo, adobeData } from '@/app/utils/Common'

import { formattedDate } from "@/app/utils/DayJS";
import { text_size, textSize } from "@/app/utils/MixinSize";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Disclaimer from "@/app/ui/Disclaimer";
import betslip from "@/app/ui/RaceDetail/components/RaceCard/ExpertColumn/mobile/betslip.json";  
import "@/app/style/expertColumn2.scss"; 
import ExpertColumnPC from "./pc/index";
import ExpertColumnM from "./mobile"; 
import { useLoading } from "@/app/utils/LoadingContext";

interface propType {
    setRacesDetailLoading: (loading: boolean) => void;
    type?: string;
    hasRaceCardInfo?: any;
}

const ExpertColumn: React.FC<propType> = (props: propType) => { 
    const { completeLoading } = useLoading();
    const { state: lang } = useLanguage();
    const { t } = lang;
    const [isExpanded, setIsExpanded] = useState(true);
    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
    const [expertName, setExpertName] = useState<string>('');

    const [horseList, setHorseList] = useState<any>([]);
    const [betTypeList, setBetTypeList] = useState<any>([]);
    const [expertHorseData, setExpertHorseData] = useState<any>([]);
    const [commentary, setCommentary] = useState<any>(null);
    const [trackAnalysisExperts, setTrackAnalysisExperts] = useState<any>(null);
    const [expertNameEn, setExpertNameEn] = useState<string>();

    const [pmPools, setPmPools] = useState<any>(null);
     
    const pagename = "Racecard-Expert";

    const handleExpand = () => {
        setIsExpanded(!isExpanded);

        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: `racing/simulcast_Click_Racecard-Expert_${!isExpanded ? "ExpandAccordion" : "CollapseAccordion"}`,
            country: myContextState.selectedMeeting?.countryNameEn || '',
            author: expertNameEn,
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeeting?.meetingVenueCode, myContextState.selectedRaceNo.valueOf()),
        });
    }
    useEffect(() => {
        if( !myContextState.season  ||
            !myContextState.selectedMeeting?.displayName ||
            !myContextState.selectedRace?.displayName) return
        getExpertColumn(
            lang.langCode,
            myContextState.season,
            myContextState.selectedMeeting?.displayName,
            myContextState.selectedRace?.displayName
        )
            .then((res: any) => {
                const data = res?.item;
                setCommentary(data?.commentary?.value);
                const hlist = [];
                const betlist = [];
                setExpertName(data?.expert.value || '')
                if (data?.expert.value) {
                    getTrackAnalysisExperts(lang.langCode, data?.expert.value || '')
                    .then((resExperts: any) => {
                        setTrackAnalysisExperts(resExperts?.item);
                        setExpertNameEn(resExperts?.enItem?.expertName?.value || "");
                    })
                    .catch((e: any) => {
                        console.log(e);
                    });
                }
                for (let index = 1; index <= 10; index++) {
                    const num = index != 10 ? "0" + index : index;
                    const horseName = data[`horseName${num}`]?.value;
                    const horseNumber = data[`horseNumber${num}`]?.value;

                    if (horseName && horseName != "") {
                        hlist.push({
                            horseName: horseName,
                            horseNumber: horseNumber
                        });
                    }

                    const betSelectionName = data[`betSelectionName${num}`]?.value;
                    const selectionLinkParameters = data[`selectionLinkParameters${num}`]?.value;
                    const betSelectionDetails = data[`betSelectionDetails${num}`]?.value;
                    const betslipLink = data[`betslipLink${num}`]?.rendered || "" as string;
                    if (betSelectionName && betSelectionName != "" && betSelectionDetails) {
                        const betL = betSelectionDetails?.split("\r\n")?.map((r: string) => r.split("\t"));
                        
                        // let _betslipLink = betslipLink || '';
                        // if (betslipLink) {
                        //     const r_link = new URLSearchParams(new URL(betslipLink).search).get('r');
                        //     if (r_link) {
                        //         _betslipLink = _betslipLink + encodeURIComponent(`?b_cid=SPLDSP_racing/simulcast-${pagename}_AddSlip`)
                        //     } 
                        // }
                        const b = {
                            title: betSelectionName,
                            link: selectionLinkParameters ? generateUrl(selectionLinkParameters, { "b_cid": `SPLDSP_racing/simulcast-${pagename}_BetType` }, false, true) : "",
                            betList: parseBetline(betSelectionName, betSelectionDetails),
                            betslipLink: betslipLink,
                        }
                        betlist.push(b);
                    }
                }
                setExpertHorseData(hlist);
                setBetTypeList(betlist);
                console.log("betlist-----", betlist, res?.item)
            })
            .catch((e: any) => {
                console.log(e);
            }).finally(() => {
                setRacesDetailLoading(props.setRacesDetailLoading)
                completeLoading('page');
            });

        getMeetingPmPoolStatus(
            formattedDate(myContextState.selectedMeetingDate, "YYYY-MM-DD"),
            myContextState.selectedMeetingVenueCode,
            ["DT", "DBL", "TBL"]
        )
        .then((res: any) => {
            setPmPools(res?.raceMeetingProfile?.[0])
        })
        .catch((e: any) => {
            console.log(e);
        }).finally(() => {
            setRacesDetailLoading(props.setRacesDetailLoading)
            completeLoading('page');
        });
            
    }, [myContextState.selectedMeeting, myContextState.selectedRace?.displayName]);
    
    useEffect(() => {
        getHorseByMeetingRace(
            formattedDate(myContextState.selectedMeetingDate, "YYYYMMDD"),
            myContextState.selectedMeetingVenueCode,
            myContextState.selectedRaceNo?.valueOf()?.toString(),
            []
        )
            .then((res: any) => {
                const horseData = res?.simulcastHorse;
                const newD = expertHorseData?.map((item: any) => {
                    const info = horseData?.find((h: any) => h[lang.langType === LANGTYPE_EN ? "name_en" : "name_ch"].toLowerCase().includes(item.horseName.toLowerCase()));

                    return {
                        horseName: item.horseName,
                        horseNameEn: info?.name_en || item.horseName,  // for WA english name
                        horseNumber: item.horseNumber,
                        link: info?.brandNumber ? generateHorseProfileUrl(
                            lang.langCode,
                            myContextState.selectedMeetingDate,
                            myContextState.selectedMeetingVenueCode,
                            myContextState.selectedRaceNo.valueOf().toString(),
                            info?.brandNumber,
                            item.horseNumber,
                            pagename) : ''
                    }
                });
                setHorseList(newD);
            })
            .catch((e: any) => {
                console.log(e);
            }).finally(() => {
                setRacesDetailLoading(props.setRacesDetailLoading)
                completeLoading('page');
            });
    }, [expertHorseData]);
    const checkIfCanShow = () => props.hasRaceCardInfo && !commentary;
    return  <Box sx={{ xs: { borderRadius: "4px" }}} id="expertcolumn2" >
                <Accordion
                    disableGutters 
                    disabled={checkIfCanShow()}
                    sx={{
                        "&.MuiPaper-root.MuiAccordion-root": {
                            boxShadow: "none", //override mui style
                            color: checkIfCanShow()? "#8b8b8b":"white",
                            "background-color": checkIfCanShow()? "#ccc": "#6176A0",
                            "border-radius": "4px",
                            "margin": "12px 0",
                            "min-height": "40px",
                            ...textSize(15)
                        },
                    }}
                    expanded={isExpanded}
                    onChange={(e) => handleExpand()}
                >
                    <AccordionSummary  
                        expandIcon={checkIfCanShow()? <KeyboardArrowUpIcon
                            sx={{
                                "&.MuiSvgIcon-root" : {
                                    color: checkIfCanShow()? "#8b8b8b":"white",
                                }
                        }}/>: <KeyboardArrowDownIcon
                            sx={{
                                "&.MuiSvgIcon-root" : {
                                    color: checkIfCanShow()? "#8b8b8b":"white",
                                }
                        }}/>}
                        aria-controls="expertcolumn" 
                        style={{
                            color: checkIfCanShow()? "#8b8b8b":"white",
                            fontWeight: 500
                        }}
                        sx={{
                            minHeight: { xs: "40px", lg: "40px" },
                        }}>
                        {t("expert_column")} {checkIfCanShow() ? t("exColoumn_Coming_Soon"): ""}
                    </AccordionSummary>

                    <AccordionDetails sx={{
                        "&.MuiAccordionDetails-root": {
                            "background-color": "#fff",
                            "color": "#122C68",
                            "border-radius": "0 0 4px 4px",
                            "padding" : checkIfCanShow()? "0" : "inherit"
                        },
                    }}>

                    {commentary ? props.type !== "pc" ? 
                    <ExpertColumnM
                        betTypeList={betTypeList}
                        commentary={commentary}
                        horseList={horseList}
                        trackAnalysisExperts={trackAnalysisExperts}
                        expertName={expertName}
                        expertNameEn={expertNameEn}
                        menuTab="raceCard"
                        pmPoolsData={pmPools}
                    />
                    :
                    <ExpertColumnPC
                        betTypeList={betTypeList}
                        commentary={commentary}
                        horseList={horseList}
                        trackAnalysisExperts={trackAnalysisExperts}
                        expertName={expertName}
                        expertNameEn={expertNameEn}
                        menuTab="raceCard"
                        pmPoolsData={pmPools}
                    />
                    : null }  

                     {/* <DivTopSolid></DivTopSolid> */}
                    {/* <BottomContentWrapper><Disclaimer /></BottomContentWrapper> */}
                    </AccordionDetails>
                </Accordion>
            </Box >
}
export default ExpertColumn

